// "Save to laptop": POST a JSON blob to the dev server, which writes it into
// src/data/. Only exists when served by Vite dev (import.meta.env.DEV); on the
// production build the button is not created.
import { button } from './controls.js';

export function saveToRepoButton(file, getJSON, log) {
  if (!import.meta.env.DEV) return null;
  return button('Save to laptop', async () => {
    try {
      const res = await fetch('/__mw/save', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ file, json: getJSON() }),
      });
      const result = await res.json();
      log(result.ok ? `saved ${result.file} on the laptop` : `save failed: ${result.error}`, result.ok ? 'info' : 'error');
    } catch (error) {
      log(`save failed: ${error.message} (are you on the dev server URL?)`, 'error');
    }
  });
}
